import { Typography, Button } from 'components'
import { setSmartContractModalState } from 'pages/home/state'

const NewSmartContractCard = () => (
	<section class='mb-5'>
		<div class='flex items-center justify-between gap-4 rounded-md bg-black-800 p-6'>
			<Typography
				class='text-[1.125rem] leading-[1.575rem]'
				color='text-black-100'
				text='Create your first Smart Contract and start coding right away.'
				variant='h4'
				weight='font-semibold'
			/>
			<Button
				className='min-w-28'
				onClick={() => setSmartContractModalState(true)}
				text='Get started'
			/>
		</div>
	</section>
)

export { NewSmartContractCard }
